import React, { FC, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import ReactWordcloud from 'react-wordcloud'
import { RootState } from '../../../../states/containers/store'
import { format } from '../../../../utils/date'
import LoadingSquare from '../../common/LoadingSquare'

interface Props {
  startDate: string
  endDate: string
}

const Wordcloud: FC<Props> = (props) => {
  const {
    startDate,
    endDate,
  } = props

  const { t } = useTranslation()

  const {
    search,
  } = useSelector((state: RootState) => (state))

  const [loading, setLoading] = useState<boolean>(true)

  const wordcloud = useMemo(() => (
    <ReactWordcloud
      words={search.searchKeyword.map((value) => ({ text: value.word, value: value.value || 0 })).slice(0, 100)}
      maxWords={100}
      options={{
        rotations: 0,
        deterministic: true,
        fontSizes: [20, 100],
        enableTooltip: false,
        fontWeight: "bold",
        fontFamily: "Noto Sans CJK JP",
      }}
    />
  ), [search.searchKeyword])

  useEffect(() => {
    if (search.isWordLoading) {
      setLoading(true)
    } else {
      setTimeout(
        () => (
          setLoading(false)
        ),
        5000,
      )
    }
  }, [search.isWordLoading])

  return (
    <>
      <section id="wordcloud" className="page_contents content-area">
        <div className="content-block wordcloud">
          <div className="block-header">
            <div className="title">
              ワードクラウド
            </div>
          </div>
          <div className="block-detail">
            {
              loading ? (
                <>
                  <LoadingSquare>
                    <>
                      ワードクラウドを生成しています…
                    </>
                  </LoadingSquare>
                </>
              ) : (
                <>
                  {
                    search.searchKeyword.length ? (
                      <div className="wordcloud_image no_trans">
                        {wordcloud}
                      </div>
                    ) : (
                      <>
                        <img src="/static/images/wordcloud-sample.png" alt="" style={{ width: "100%", margin: "20px 0" }} />
                        <div className="no_image">
                          <div className="title">
                            {t('search.index.no_image.title', {
                              date: `${format(startDate)} 〜 ${format(endDate)}` })}
                          </div>
                          <div className="message">
                            {t('search.index.no_image.message')}
                          </div>
                        </div>
                      </>
                    )
                  }
                </>
              )
            }
          </div>
        </div>
      </section>
    </>
  )
}

export default Wordcloud
